module.exports = __webpack_public_path__ + "static/media/39-iveco.ed416765.jpg";